import { encodeParams, removeEmptyParams } from '@prophecy/utils/data';
import { appendQueryParams } from '@prophecy/utils/url';

import { FINANCE_BASE, PROFESSIONAL_BASE } from './constants';

type QueryParams = Record<string, string | string[] | undefined | null>;

// `query-string` keeps `null` as a value-less key (`?branch`); strip both null and
// undefined so a caller passing either produces the same URL as omitting the field.
function withQuery(path: string, params?: QueryParams): string {
  if (!params) return path;
  const cleaned = removeEmptyParams(params);
  if (!Object.keys(cleaned).length) return path;
  return appendQueryParams(path, cleaned as Record<string, string | string[]>);
}

const encodePathParam = (v: string) => encodeParams({ v }).v;

// Port of FE `getSqlIDEUrl` (frontend/core/src/common/url.ts:523): vApp base
// (`/professional`, `/finance`) uses `/project/:uid`, everyone else `/sql/:uid`.
export function getSqlIDEUrlPath(basePath: string, uid: string, params?: QueryParams): string {
  const isVApp = basePath === PROFESSIONAL_BASE || basePath === FINANCE_BASE;
  return withQuery((isVApp ? '/project/' : '/sql/') + encodePathParam(uid), params);
}

// Port of FE `getIDEUrl` (frontend/core/src/common/url.ts:515): entity is
// lowercased in the `/ide/:entity/:uid` path.
export function getIDEUrlPath(entity: string, uid: string, params?: QueryParams): string {
  return withQuery(`/ide/${encodePathParam(entity.toLowerCase())}/${encodePathParam(uid)}`, params);
}
